export type PlateInfo = {
    licensePlateNumber: string;
    plateType: 'PASSENGER' | 'COMMERCIAL' | 'MOTORCYCLE';
    graphicChoice?: string;
    sloganChoice?: string;
};

export type TotalItemCost = {
    unitCost: number;
    taxCode: 'HST';
    taxRate: number
    taxAmount: number;
    totalCost: number;
};

export type ProductFee = {
    unitCost: number;
    taxCode: string;
    taxRate: number;
    taxAmount: number;
    totalCost: number;
};

export type AdditionalFees = {
    unitCost: number;
    taxCode: 'HST',
    taxRate: number;
    taxAmount: number;
    totalCost: number;
    feeType: string;
};

export type PriceBreakdown = {
    plateInfo: PlateInfo;
    totalItemCost: TotalItemCost;
    productFee: ProductFee;
    additionalFee: AdditionalFees
}[];

export type PlpResponseData = {
    Response: {
        priceBreakdown: PriceBreakdown;
        totalAmount: number;
        statusCode: number;
    }
};

export type CheckPlateRequest = {
    identificationType: string,
    driverLicenceNumber : string,
    registrantInformationNumber: string,
    plateNumber: string,
    plateType: string,
    graphicChoice: string,
    sloganChoice: string,
    token?: string
}

export enum SERVICE_CALL_RESPONSE_CODES {
    COMPLETE_PAYMENT_SUCCESSFUL = '0',
    PROCESS_SUCCESSFUL = '20',
    RIN_DL_NOT_EXISTS = 'CXPPLP101',
    DL_NOT_MOST_CURRENT = 'CXPPLP102',
    RIN_INVALID_TYPE = 'CXPPLP113',
    PLATE_CHARACTERS_UNAVAILABLE = 'CXPPLP104',
    PLATE_CHARACTERS_INVALID_FORMAT = 'CXPPLP110',
    PLATE_INVALID_PREFIX = 'CXPPLP115',
    CONTAINS_INTERCHANGEABLE_CHARACTERS = 'CXPPLP403'
}
